<script setup lang="ts">
import usePoolStore from '~~/app/store/pool'
import { getSafeName } from '~~/app/utils/format'

const poolStore = usePoolStore()

defineProps({
    isContainedInDrawer: { type: Boolean, default: true }
})

const onClickOnCityName = () => {
    if (window.location !== window?.parent?.location) {
        ;(window.top as Window).postMessage(
            {
                action: 'openUrl',
                url: `cities/${getSafeName(poolStore.getCity)}-${
                    poolStore.getCountryCode
                }`
            },
            document.referrer
        )
    } else {
        return navigateTo(
            getChargemapUrl(
                `/cities/${getSafeName(poolStore.getCity)}-${poolStore.getCountryCode}`
            ),
            { external: true }
        )
    }
}
</script>

<template>
    <div class="flex items-center" :class="{ 'mb-4': isContainedInDrawer }">
        <div v-if="isContainedInDrawer" class="text-gray-l-500 text-0.5sm">
            <p>{{ poolStore.getStreetNumber }} {{ poolStore.getStreetName }}</p>
            <p>
                {{ poolStore.getPostalCode }}
                <span
                    class="text-[#0080C5] cursor-pointer"
                    @click="onClickOnCityName"
                >
                    {{ poolStore.getCity }}
                </span>
            </p>
            <p>
                {{ poolStore.getCountryName }}
            </p>
        </div>
        <div v-else class="w-full text-gray-l-500 text-0.5sm">
            <div>
                <span>
                    {{ poolStore.getStreetNumber }}
                    {{ poolStore.getStreetName }}
                </span>
                <span>&nbsp;-&nbsp;</span>
                <span>
                    {{ poolStore.getPostalCode }}
                    <span
                        class="text-[#0080C5] cursor-pointer"
                        @click="onClickOnCityName"
                    >
                        {{ poolStore.getCity }}
                    </span>
                </span>
                <span>&nbsp;-&nbsp;</span>
                <span>
                    {{ poolStore.getCountryName }}
                </span>
            </div>
            <NuxtLink target="_blank" :to="poolStore.getDirectionLink">
                <ChargemapB2CButton
                    type="tertiary"
                    size="large"
                    class="ml-auto"
                >
                    <template #icon>
                        <IconLaunchGps class="size-4" />
                    </template>
                    {{ $t('pool.display_route') }}
                </ChargemapB2CButton>
            </NuxtLink>
        </div>
    </div>
</template>
